<template>
    <!-- 社会治理 -->
    <div class="main">
        <!-- nav bar -->
        <!-- main -->
        <!-- 路由 -->
        <!-- <transition :name="transitionName"> -->
        <!-- <transition> -->
        <router-view class="router-main"></router-view>
        <!-- </transition> -->
    </div>
</template>

<script>
// import "@/assets/css/platform.css";
import "@/assets/css/sectionBox.css";
import { removeAuthor } from "../utils/author";
export default {
  name: "systemIndex",
    data() {
        return {
            Admin: "Admin",
            routeName: "", //当前展示子路由的路由名称
            transitionName: "" //定义过渡动画名称
        };
    },
    // 路由创建,更新时. 获取当前路由名称 用来给li动态绑定样式
    created() {
        this.getPageUrl();
    },
    computed: {
        menu() {
            let arr = [];
            let menu = this.$store.state.menu;
            for (let item in menu) {
                if (menu[item].menuType == "1") {
                    arr.push(menu[item].path);
                }
            }
            return arr;
        }
    },

    updated() {
        this.getPageUrl();
    },
    methods: {
        gopage(pageName) {
            this.$router.push({ name: pageName });
            this.routeName = pageName;
        },
        loginout(pageName) {
            removeAuthor("user");
            this.$router.push({ name: pageName });
        },
        // 获取当前页面路由名称
        getPageUrl() {
            // window.console.log(this.$route);
            this.routeName = this.$route.matched[1].name;
        }
    }
   
};
</script>

